import { FC, useState } from 'react';
import { Fab, Drawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import NavMenueList from './NavMenuList';
import useMedia from '../../hooks/useMedia';

const NavMenu: FC = () => {
  const [open, setOpen] = useState(false);

  const isMobile = useMedia('md');

  const setDrawer = (state: boolean) => {
    setOpen(state);
  };

  return (
    <div>
      {isMobile ? (
        <>
          {!open && (
            <Fab
              sx={{
                position: 'absolute',
                top: '-74px',
                right: '8px',
              }}
              onClick={() => setDrawer(true)}
            >
              <MenuIcon />
            </Fab>
          )}
          <Drawer anchor="right" open={open} onClose={() => setDrawer(false)}>
            <NavMenueList />
          </Drawer>
        </>
      ) : (
        <NavMenueList />
      )}
    </div>
  );
};

export default NavMenu;
